import * as React from 'react';
import { withRouter } from 'react-router-dom';

import { mapClusterURLToID, mapSelectedPoolURLToID } from 'defs/pools';
import { WithRouterType } from 'types/withRouter';

import PoolView from 'containers/views/PoolView';
import { PoolClusterType, PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

export type PoolRootRendererPropsType = WithRouterType & {};

class PoolRootRenderer extends React.Component<PoolRootRendererPropsType> {
	public static displayName = 'Pool(RootRenderer)';

	public getSelectedPoolURL(props: PoolRootRendererPropsType = this.props): string {
		return props.match.params.selectedPool.toString() || '';
	}

	public getSelectedClusterURL(props: PoolRootRendererPropsType = this.props): string {
		return props.match.params.selectedCluster ? props.match.params.selectedCluster.toString() : '';
	}

	public render() {
		const selectedPoolURL = this.getSelectedPoolURL();
		const selectedPoolID: PoolEnumType = mapSelectedPoolURLToID[selectedPoolURL] || undefined;

		const clusterURL = this.getSelectedClusterURL();
		const clusterID: PoolClusterType = mapClusterURLToID[clusterURL];

		return <PoolView selectedPool={selectedPoolID} selectedCluster={clusterID} />;
	}
}

export default withRouter(PoolRootRenderer as any);
